import RiyalWhite from '../../assets/used-icons/riyal.png'
import RiyalBlack from '../../assets/used-icons/riyal-black.png'

export default function Riyal({ color }) {
    return (
        <span>
            {color === 'black' ?
                <img src={RiyalBlack} alt="riyal" className='w-4' />
                :
                <img src={RiyalWhite} alt="riyal" className='w-4' />
            }
        </span>
    )
}